const columns = [
  {
    name: 'Full Name',
    selector: (row) => row.attributes.full_name,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.attributes.email,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Role',
    selector: (row) => row.attributes.role,
    sortable: true,
  },
  {
    name: 'Team',
    selector: (row) => row.attributes.team,
    sortable: true,
  },
  {
    name: 'Date Created',
    selector: (row) => new Date(row.attributes.created_at),
    sortable: true,
    cell: (row) => {
      const date = new Date(row.attributes.created_at);

      return date.toLocaleDateString('en-US');
    },
  },
];

export default columns;
